// Domain-agnostic color tokens and date-range helpers shared by every
// manager-dashboard statistics page (see components/StatisticsDashboard).
export const CATEGORICAL_COLORS = [
    '#2a78d6',
    '#eb6834',
    '#1baf7a',
    '#eda100',
    '#e87ba4',
    '#008300',
    '#4a3aa7',
    '#e34948',
];

export const STATUS_COLORS = {
    good: '#0ca30c',
    warning: '#fab219',
    serious: '#ec835a',
    critical: '#d03b3b',
};

export const CHART_INK = {
    primary: '#0b0b0b',
    secondary: '#52514e',
    muted: '#898781',
    grid: '#e1e0d9',
    axis: '#c3c2b7',
};

const HEBREW_MONTHS = ['ינו', 'פבר', 'מרץ', 'אפר', 'מאי', 'יונ', 'יול', 'אוג', 'ספט', 'אוק', 'נוב', 'דצמ'];

export const formatMonthLabel = (year, month) => `${HEBREW_MONTHS[month - 1]}-${String(year).slice(2)}`;

export const getDefaultMonthRange = () => {
    const now = new Date();
    const toMonthInput = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    const fromDate = new Date(now.getFullYear() - 1, now.getMonth(), 1);
    const fromMonthInput = `${fromDate.getFullYear()}-${String(fromDate.getMonth() + 1).padStart(2, '0')}`;
    return { fromMonthInput, toMonthInput };
};

export const monthInputToRange = (fromMonthInput, toMonthInput) => {
    const [fromYear, fromMonth] = fromMonthInput.split('-').map(Number);
    const [toYear, toMonth] = toMonthInput.split('-').map(Number);
    const startDate = new Date(fromYear, fromMonth - 1, 1);
    const endDate = new Date(toYear, toMonth, 0, 23, 59, 59, 999);
    return { startDate: startDate.toISOString(), endDate: endDate.toISOString() };
};
